module.exports = __webpack_public_path__ + "static/media/cloud_watch5.1c2b92ad.png";